import React from 'react'
import { image } from '../../Assets';
import './specialitySection.scss';

const SpecialitySection = () => {
  return (
    <div className="speciality-Section">
      <div className="container">
        <div className="row">
            <div className="col-sm-3 col-12">
                <div className="specbox" style={{background:`url(${image.educationSectorImg})`}}>
                    <h4>Education</h4>                    
                    <svg width="54" height="27" viewBox="0 0 54 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.12896 2.31179C0.592453 1.31515 1.29091 0.0433139 2.42279 0.0433139C12.6258 0.0346722 26.8283 0.0778781 37.0228 0.000102688C38.6778 -0.00853903 39.565 0.52725 40.3754 1.9877C45.366 10.8973 47.7127 15.6012 52.7715 24.4763C52.82 24.5611 52.8678 24.6464 52.9154 24.7328C53.4498 25.7029 52.7615 26.9564 51.654 26.9564C41.451 26.9651 27.2485 26.9219 17.054 26.9996C15.3052 27.0169 14.3582 26.412 13.5051 24.8738C8.57424 16.016 6.27024 11.3726 1.26258 2.55806C1.21779 2.47619 1.17333 2.3942 1.12896 2.31179Z" fill="white"/>
                    <path d="M21 14H33M33 14L28.9149 10M33 14L28.9149 18" stroke="#157438"/>
                    </svg>
                </div>
            </div>
            <div className="col-sm-3 col-12">
                <div className="specbox" style={{background:`url(${image.constructiomsector})`}}>
                    <h4>Construction</h4>                    
                    <svg width="54" height="27" viewBox="0 0 54 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.12896 2.31179C0.592453 1.31515 1.29091 0.0433139 2.42279 0.0433139C12.6258 0.0346722 26.8283 0.0778781 37.0228 0.000102688C38.6778 -0.00853903 39.565 0.52725 40.3754 1.9877C45.366 10.8973 47.7127 15.6012 52.7715 24.4763C52.82 24.5611 52.8678 24.6464 52.9154 24.7328C53.4498 25.7029 52.7615 26.9564 51.654 26.9564C41.451 26.9651 27.2485 26.9219 17.054 26.9996C15.3052 27.0169 14.3582 26.412 13.5051 24.8738C8.57424 16.016 6.27024 11.3726 1.26258 2.55806C1.21779 2.47619 1.17333 2.3942 1.12896 2.31179Z" fill="white"/>
                    <path d="M21 14H33M33 14L28.9149 10M33 14L28.9149 18" stroke="#157438"/>
                    </svg>
                    
                </div>
            </div>
            <div className="col-sm-3 col-12">
                <div className="specbox" style={{background:`url(${image.hospitalitysector})`}}>
                    <h4>Hospitality</h4>                    
                    <svg width="54" height="27" viewBox="0 0 54 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.12896 2.31179C0.592453 1.31515 1.29091 0.0433139 2.42279 0.0433139C12.6258 0.0346722 26.8283 0.0778781 37.0228 0.000102688C38.6778 -0.00853903 39.565 0.52725 40.3754 1.9877C45.366 10.8973 47.7127 15.6012 52.7715 24.4763C52.82 24.5611 52.8678 24.6464 52.9154 24.7328C53.4498 25.7029 52.7615 26.9564 51.654 26.9564C41.451 26.9651 27.2485 26.9219 17.054 26.9996C15.3052 27.0169 14.3582 26.412 13.5051 24.8738C8.57424 16.016 6.27024 11.3726 1.26258 2.55806C1.21779 2.47619 1.17333 2.3942 1.12896 2.31179Z" fill="white"/>
                    <path d="M21 14H33M33 14L28.9149 10M33 14L28.9149 18" stroke="#157438"/>
                    </svg>                    
                </div>
            </div>
            <div className="col-sm-3 col-12">
                <div className="specbox" style={{background:`url(${image.healthcaresector})`}}>
                    <h4>Healthcare</h4>                    
                    <svg width="54" height="27" viewBox="0 0 54 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.12896 2.31179C0.592453 1.31515 1.29091 0.0433139 2.42279 0.0433139C12.6258 0.0346722 26.8283 0.0778781 37.0228 0.000102688C38.6778 -0.00853903 39.565 0.52725 40.3754 1.9877C45.366 10.8973 47.7127 15.6012 52.7715 24.4763C52.82 24.5611 52.8678 24.6464 52.9154 24.7328C53.4498 25.7029 52.7615 26.9564 51.654 26.9564C41.451 26.9651 27.2485 26.9219 17.054 26.9996C15.3052 27.0169 14.3582 26.412 13.5051 24.8738C8.57424 16.016 6.27024 11.3726 1.26258 2.55806C1.21779 2.47619 1.17333 2.3942 1.12896 2.31179Z" fill="white"/>
                    <path d="M21 14H33M33 14L28.9149 10M33 14L28.9149 18" stroke="#157438"/>
                    </svg>                    
                </div>
            </div>
        </div>
        <div className="row tw-items-center">
            <div className='d-flex achievement-section tw-items-center'>
                <div className="col-sm-6" style={{padding:'40px'}}> 
                    <h3>We design and develop better for seamless operations</h3>
                </div>
                <div className="col-sm-2">
                    <div className="achivement">
                        <h4><b>100+ </b></h4>
                        <p>Completed Projects</p>
                    </div>
                </div>
                <div className="col-sm-2"><div className="achivement">
                        <h4><b>$45M </b> </h4>
                        <p>Revenue Generated</p>
                    </div></div>
                <div className="col-sm-2"><div className="achivement">
                        <h4><b>10x </b></h4>
                        <p>Efficiency in Delivery </p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default SpecialitySection
